import { render, staticRenderFns } from "./CO2.vue?vue&type=template&id=5b7c7cce&scoped=true"
import script from "./CO2.vue?vue&type=script&lang=ts"
export * from "./CO2.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7c7cce",
  null
  
)

export default component.exports